export const REDUX_SLICE = {
  APP: 'app',
} as const;
